<template>
  <div>
    <div>
      <span class="xbed-sub-title">业主详情</span>
    </div>

    <div class="xbed-breadcrumb">
      <Breadcrumb>
        <BreadcrumbItem href="/">蓝主人</BreadcrumbItem>
        <BreadcrumbItem>业主详情</BreadcrumbItem>
      </Breadcrumb>
    </div>

    <Tabs value="detail">
      <TabPane label="业主信息" name="detail">
        <Form>
        <FormItem label="姓名／公司名" :label-width="100">
          <Input type="text" v-model="hoster.name" :disabled="!editable"></Input>
        </FormItem>
        <FormItem label="性别" :label-width="100">
          <Select type="text" v-model="hoster.gender" :disabled="!editable">
            <Option :value="1">男</Option>
            <Option :value="0">女</Option>
          </Select>
        </FormItem>
        <FormItem label="手机号码" :label-width="100">
          <Input type="text" v-model="hoster.mobile" :disabled="!editable"></Input>
        </FormItem>
        <FormItem label="邮箱" :label-width="100">
          <Input type="text" v-model="hoster.email" :disabled="!editable"></Input>
        </FormItem>
        <FormItem label="省份" :label-width="100">
          <Input type="text" v-model="hoster.province" :disabled="!editable"></Input>
        </FormItem>
        <FormItem label="市" :label-width="100">
          <Input type="text" v-model="hoster.city" :disabled="!editable"></Input>
        </FormItem>
        <FormItem label="地区" :label-width="100">
          <Input type="text" v-model="hoster.district" :disabled="!editable"></Input>
        </FormItem>
        <FormItem label="详细地址" :label-width="100">
          <Input type="text" v-model="hoster.stressAddress" :disabled="!editable"></Input>
        </FormItem>
        <FormItem label="账户性质" :label-width="100">
          <Select type="text" v-model="hoster.isMaker" :disabled="!editable">
            <Option :value="1">个人</Option>
            <Option :value="2">企业</Option>
          </Select>
        </FormItem>
        <FormItem label="是否创客" :label-width="100">
          <Select type="text" v-model="hoster.isMaker" :disabled="!editable">
            <Option :value="1">是</Option>
            <Option :value="0">否</Option>
          </Select>
        </FormItem>
        <FormItem v-if="hoster.isMaker === 1" label="所属开发人员" :label-width="100">
          <Input type="text" v-model="hoster.developerId" :disabled="!editable"></Input>
        </FormItem>
        <FormItem label="开户银行名称" :label-width="100">
          <Input type="text" v-model="hoster.bankname" :disabled="!editable"></Input>
        </FormItem>
        <FormItem label="开户名" :label-width="100">
          <Input type="text" v-model="hoster.bankname" :disabled="!editable"></Input>
        </FormItem>
        <FormItem label="银行账号" :label-width="100">
          <Input type="text" v-model="hoster.bankaccount" :disabled="!editable"></Input>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="toggleEdit">{{editable? '保存' : '修改业主' }}</Button>
        </FormItem>
      </Form>
      </TabPane>
      <TabPane label="协议" name="agreement">
        <Table :columns="agreement"></Table>
      </TabPane>
      <TabPane label="房间" name="room">
        <Table :columns="room"></Table>
      </TabPane>
    </Tabs>

  </div>
</template>

<script>
export default {
  data(){
    return {
      hoster:{},
      editable: false,
      agreement:[
        {
          title: "ID",
          key: "id",
          align: "center",
        },
        {
          title: "协议编号",
          key: "id",
          align: "center",
        },
        {
          title: "协议状态",
          key: "id",
          align: "center",
        },
        {
          title: "协议类型",
          key: "id",
          align: "center",
        },
        {
          title: "乙方",
          key: "id",
          align: "center",
        },
        {
          title: "房间数量",
          key: "id",
          align: "center",
        },
        {
          title: "开始日期",
          key: "id",
          align: "center",
        },
        {
          title: "结束日期",
          key: "id",
          align: "center",
        },
        {
          title: "操作",
          key: "id",
          align: "center",
        },
      ],
      room:[
        {
          title: "ID",
          key: "id",
          align: "center",
        },
        {
          title: "协议ID",
          key: "id",
          align: "center",
        },
        {
          title: "房间名称",
          key: "id",
          align: "center",
        },
        {
          title: "房间类型",
          key: "id",
          align: "center",
        },
        {
          title: "房间状态",
          key: "id",
          align: "center",
        },
        {
          title: "房源类型",
          key: "id",
          align: "center",
        },
        {
          title: "上线日期",
          key: "id",
          align: "center",
        },
        {
          title: "下线日期",
          key: "id",
          align: "center",
        },
        {
          title: "操作",
          key: "id",
          align: "center",
        },
      ]
    }
  },
  methods:{
    toggleEdit(){
      this.editable = !this.editable;
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/pages/blue-hoster/hoster-detail.vue